import React from "react";

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({
  className = "",
  width = 200,
  height = 80,
}) => {
  return (
    <div className="w-8 h-8 rounded-lg flex items-center justify-center">
      {/* <span className="text-white font-bold text-lg">P</span> */}
      <img src="/logo_no_bg.png" alt="PhilTrade Logo" className="w-full h-full object-contain" />
    </div>
  );
};

export default Logo;
